import React, { useState, useEffect } from 'react';
import { MatrixLock, MatrixRefresh, MatrixCheckCircle, MatrixXCircle } from '../components/MatrixEmojis';
import { 
  signInWithPopup, 
  GoogleAuthProvider,
  signOut 
} from 'firebase/auth';
import { auth } from '../config/firebase';

const MultiLoginTestPage = () => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState('');
  const [error, setError] = useState('');
  const [firebaseStatus, setFirebaseStatus] = useState('checking');

  // Check Firebase connection on component mount
  useEffect(() => {
    const checkFirebaseConfig = async () => {
      try {
        console.log('Firebase Auth instance:', auth);
        console.log('Firebase App:', auth.app);
        console.log('Firebase Config:', auth.app.options);
        setFirebaseStatus('connected');
      } catch (error) {
        console.error('Firebase connection error:', error);
        setFirebaseStatus('error');
        setError(`Firebase connection failed: ${error.message}`);
      }
    };

    checkFirebaseConfig();
  }, []);
  const handleGoogleLogin = async () => {
    setLoading('google');
    setError('');
    
    try {
      const provider = new GoogleAuthProvider();
      provider.addScope('email');
      provider.addScope('profile');
      
      console.log('Attempting Google sign-in...');
      const result = await signInWithPopup(auth, provider);
      const user = result.user;
      
      console.log('Google login successful:', user);
      setUser({
        provider: 'Google',
        uid: user.uid,
        email: user.email,
        displayName: user.displayName,
        photoURL: user.photoURL,
        emailVerified: user.emailVerified,
        accessToken: result._tokenResponse?.idToken || 'No token'
      });
      
    } catch (error) {
      console.error('Google login error:', error);
      handleAuthError(error, 'Google');
    } finally {      setLoading('');
    }
  };

  const handleAuthError = (error, provider) => {
    if (error.code === 'auth/configuration-not-found') {
      setError(`${provider} Authentication not configured: Please check Firebase Console settings.`);
    } else if (error.code === 'auth/popup-closed-by-user') {
      setError(`${provider} sign-in was cancelled by user.`);
    } else if (error.code === 'auth/popup-blocked') {
      setError(`Popup blocked. Please allow popups for this site and try again.`);
    } else {
      setError(`${provider} login failed: ${error.message}`);
    }
  };

  const handleLogout = async () => {
    try {
      await signOut(auth);
      setUser(null);
      console.log('User logged out successfully');
    } catch (error) {
      console.error('Logout error:', error);
      setError(`Logout failed: ${error.message}`);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 py-12 px-4">
      <div className="max-w-2xl mx-auto">
        <div className="bg-white rounded-xl shadow-lg p-8">          <h1 className="text-3xl font-bold text-center text-gray-800 mb-8">
            <MatrixLock size="24" /> Multi-Provider Login Test
          </h1>

          {/* Firebase Status */}
          <div className={`mb-6 p-4 rounded-lg ${
            firebaseStatus === 'connected' ? 'bg-green-100 border border-green-400 text-green-700' :
            firebaseStatus === 'error' ? 'bg-red-100 border border-red-400 text-red-700' :
            'bg-yellow-100 border border-yellow-400 text-yellow-700'          }`}>            <strong>Firebase Status:</strong> {              firebaseStatus === 'connected' ? <><MatrixCheckCircle className="matrix-emoji-green" size="18" /> Connected</> :
              firebaseStatus === 'error' ? <><MatrixXCircle className="matrix-emoji-red" size="18" /> Error</> :
              <><MatrixRefresh size="20" /> Checking...</>
            }
            {firebaseStatus === 'connected' && (
              <div className="text-sm mt-2">
                <div>Project ID: officialvishwatejaweb</div>
                <div>Auth Domain: officialvishwatejaweb.firebaseapp.com</div>
                <div className="text-green-600 font-medium mt-1"><MatrixCheckCircle className="matrix-emoji-green" size="18" /> Google Sign-in Enabled</div>
              </div>
            )}
          </div>
          
          {error && (
            <div className="mb-6 p-4 bg-red-100 border border-red-400 text-red-700 rounded-lg">
              <strong>Error:</strong> {error}
              {error.includes('configuration-not-found') && (
                <div className="mt-3 p-3 bg-blue-50 rounded border-l-4 border-blue-400">
                  <strong className="text-blue-800">Quick Fix:</strong>
                  <ol className="text-blue-700 text-sm mt-2 ml-4 list-decimal">
                    <li>Go to <a href="https://console.firebase.google.com/project/officialvishwatejaweb/authentication/providers" target="_blank" rel="noopener noreferrer" className="underline">Firebase Console</a></li>
                    <li>Click "Authentication" → "Sign-in method"</li>
                    <li>Enable "Google" provider</li>
                    <li>Add support email and save</li>
                  </ol>
                </div>
              )}
            </div>
          )}
            {!user ? (
            <div className="text-center">
              <p className="text-gray-600 mb-6">
                Test Google authentication integration with Firebase
              </p>
              
              <div className="space-y-4">
                {/* Google Sign-in Button */}
                <button
                  onClick={handleGoogleLogin}
                  disabled={loading === 'google'}
                  className="w-full inline-flex items-center justify-center px-6 py-3 bg-red-500 hover:bg-red-600 disabled:bg-gray-400 text-white font-medium rounded-lg transition-colors duration-200"
                >
                  {loading === 'google' ? (
                    <>
                      <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                        <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                      </svg>
                      Signing in with Google...
                    </>
                  ) : (
                    <>
                      <svg className="w-5 h-5 mr-3" viewBox="0 0 24 24">
                        <path fill="currentColor" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
                        <path fill="currentColor" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
                        <path fill="currentColor" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
                        <path fill="currentColor" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
                      </svg>
                      Sign in with Google
                    </>
                  )}
                </button>
              </div>
            </div>
          ) : (
            <div className="space-y-6">{/* Content */}
              <div className="text-center">                <h2 className="text-2xl font-semibold text-green-600 mb-4">
                  <MatrixCheckCircle className="matrix-emoji-green" size="24" /> Login Successful!
                </h2>
                
                {user.photoURL && (
                  <img 
                    src={user.photoURL} 
                    alt="Profile" 
                    className="w-20 h-20 rounded-full mx-auto mb-4 border-4 border-green-200"
                  />
                )}
              </div>
              
              <div className="bg-gray-50 rounded-lg p-6">
                <h3 className="text-lg font-semibold mb-4 text-gray-800">User Information:</h3>
                <div className="space-y-3 text-sm">
                  <div className="flex justify-between">
                    <span className="font-medium text-gray-600">UID:</span>
                    <span className="text-gray-800 font-mono text-xs bg-white px-2 py-1 rounded">
                      {user.uid}
                    </span>
                  </div>
                  <div className="flex justify-between">
                    <span className="font-medium text-gray-600">Name:</span>
                    <span className="text-gray-800">{user.displayName}</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="font-medium text-gray-600">Email:</span>
                    <span className="text-gray-800">{user.email}</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="font-medium text-gray-600">Email Verified:</span>                    <span className={`${user.emailVerified ? 'text-green-600' : 'text-red-600'}`}>
                      {user.emailVerified ? <><MatrixCheckCircle className="matrix-emoji-green" size="18" /> Yes</> : <><MatrixXCircle className="matrix-emoji-red" size="18" /> No</>}
                    </span>
                  </div>
                  <div className="flex justify-between items-start">
                    <span className="font-medium text-gray-600">Access Token:</span>
                    <span className="text-gray-800 font-mono text-xs bg-white px-2 py-1 rounded max-w-xs truncate">
                      {user.accessToken.substring(0, 50)}...
                    </span>
                  </div>
                </div>
              </div>
              
              <div className="flex justify-center space-x-4">
                <button
                  onClick={handleLogout}
                  className="px-6 py-2 bg-gray-500 hover:bg-gray-600 text-white font-medium rounded-lg transition-colors duration-200"
                >
                  Sign Out
                </button>
                
                <button
                  onClick={() => navigator.clipboard.writeText(JSON.stringify(user, null, 2))}
                  className="px-6 py-2 bg-blue-500 hover:bg-blue-600 text-white font-medium rounded-lg transition-colors duration-200"
                >
                  Copy User Data
                </button>
              </div>
            </div>
          )}
          
          <div className="mt-8 p-4 bg-blue-50 rounded-lg">
            <h4 className="font-semibold text-blue-800 mb-2">Test Information:</h4>
            <ul className="text-sm text-blue-700 space-y-1">
              <li>• This page tests Firebase Google Authentication</li>
              <li>• Check browser console for detailed logs</li>
              <li>• User data is stored in component state only</li>
              <li>• Perfect for debugging auth integration</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MultiLoginTestPage;
